// f0, i.e. A4 frequency
const A4 = 440;

// abc notation stuff:
const validNotes = 'cdefgabCDEFGAB';
const validSigns = '^_,';
const reservedWords = ['!wedge!'];
const breath = '!breath!'

// names:
const traditionalNames = ['Do', 'Re', 'Mi', 'Fa', 'Sol', 'La', 'Si'];
export const noteStrings = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export const noteCleaner = note => {
  note = note.replace(breath,"");
  let first = note.trim().replace(/\d/g, '');
  let ret = '';
  
  reservedWords.forEach(word => {
    if (first.indexOf(word) >= 0) {
      const re = new RegExp(word, 'g');
      first = first.replace(re, '');
    }
  });
  for (let i = 0; i < first.length; i++) {
    if (validNotes.includes(first[i])) {
      ret += first[i];
    } else if (validSigns.includes(first[i])) {
      ret += first[i];
    }
  }
  return ret;
};

export class Note {
  constructor(pitch, accidental, duration, frequency, noteNumber, octave, timestamp) {
    //english name
    this.pitch = pitch;
    // string with sharp/flat. null if plain note.
    this.accidental = accidental;
    // tempo in millisecondi.
    this.duration = duration;
    this.frequency = frequency;
    this.octave = octave;
    this.timestamp = timestamp;
    // numero di semitoni a partire da C0
    this.noteNumber = noteNumber;
  }

  equals = note => {
    return this.pitch === note.pitch && this.accidental === note.accidental && this.octave === note.octave;
  };

  accidentalString = () => {
    if (this.accidental) return this.accidental === 'sharp' ? '#' : '♭';
    return '';
  };

  traditionalName = () => {
    const index = validNotes.indexOf(this.pitch.toLowerCase());
    return traditionalNames[index] + this.accidentalString();
  };

  toString = () => {
    return `[${this.timestamp}] ${this.noteNumber} ${this.pitch}/${this.traditionalName()} ${this.octave} - ${
      this.frequency
    }Hertz  - durata: ${this.duration}`;
  };

  toAbcString = default_length => {
    let string = this.pitch;

    if (this.octave < 4) string = string + ',';
    if (this.octave > 4) string = string.toLowerCase();
    if (this.octave > 5) string = string + "'";

    if (this.duration) {
      const ratio = this.duration / default_length;
      if (ratio > 1) {
        string += ratio;
      } else if (ratio < 1) {
        string += '/' + ratio;
      }
    }
    if (this.accidental) {
      string = (this.accidental === 'sharp' ? '^' : '_') + string;
    }
    return string;
  };
}

export const noteFromAbcNote = abc_note => {
  abc_note = abc_note.replace(breath,"");
  // per adesso tolgo i tempi:
  abc_note = abc_note.trim().replace(/\d/g, '');
  let accidental = null;
  let octave = 0;
  // di default:
  // note con ',' = 3° ottava
  // note uppercase = 4° ottava
  // note lowercase = 5° ottava
  // note con ' = 6° ottava
  const re = new RegExp('[_^]');
  if (re.test(abc_note)) {
    const idx = re.exec(abc_note).index;
    if (abc_note[idx] === '^') accidental = 'sharp';
    else accidental = 'flat';
  }
  const octave_re = new RegExp("[,']");
  if (octave_re.test(abc_note)) {
    const idx = octave_re.exec(abc_note).index;
    if (abc_note[idx] === ',') octave = 3;
    else octave = 6;
  }
  reservedWords.forEach(word => {
    if (abc_note.indexOf(word) >= 0) {
      const re = new RegExp(word, 'g');
      abc_note = abc_note.replace(re, '');
    }
  });
  // estraggo la prima lettera che rappresenta una nota:
  let match = abc_note.match(new RegExp('([abcdefgABCDEFG])'));
  if (match) {
    let pitch = match[0];
    const ts = new Date().getTime();
    if (octave === 0) {
      octave = pitch === pitch.toUpperCase() ? 4 : 5;
    }
    const ret = new Note(pitch, accidental, 0, null, 0, octave, ts);
    return ret;
  } else return null;
};

// taken from: https://www.johndcook.com/blog/2016/02/10/musical-pitch-notation/
const C0 = A4 * Math.pow(2, -4.75);
const getPitchOctaveFromFrequency = freq => {
  const noteNumber = Math.round(12 * Math.log2(freq / C0));
  const octave = Math.floor(noteNumber / 12);
  const h = noteNumber % 12;
  const pitch = noteStrings[h];
  return { pitch, octave, noteNumber };
};

export const noteFromFrequency = frequency => {
  const { pitch, octave, noteNumber } = getPitchOctaveFromFrequency(frequency);
  const accidental = pitch.length === 2 ? 'sharp' : null;
  const timestamp = new Date().getTime();
  const retNote = new Note(pitch[0], accidental, 0, frequency, noteNumber, octave, timestamp);
  return retNote;
};

export const frequencyFromNote = note => {
  const noteName = note.pitch + note.accidentalString();
  const noteIndex = noteStrings.indexOf(noteName);
  const noteNumber = 12 * note.octave + noteIndex;
  const A4Number = 12 * 4 + noteStrings.indexOf('A');
  const foundFrequency = A4 * Math.pow(2, (noteNumber - A4Number) / 12);
  return foundFrequency;
};

export const findLyricsByPlayedPath = (canvas,path) => {
  //const canvas = this.abcjsCanvasRef.current;
  // prendi i dettagli di path che ci interessano
  let searchedClass = 'abcjs-lyric';
  path.classList.forEach(className => {
    if (
      className.startsWith('abcjs-l') ||
      className.startsWith('abcjs-m') ||
      className.startsWith('abcjs-v') ||
      (className.startsWith('abcjs-n') && className !== 'abcjs-note')
    )
      searchedClass += ' ' + className;
  });
  const result_paths = canvas.getElementsByClassName(searchedClass);
  if (result_paths.length !== 1) {
    console.log('WARNING found ', result_paths.length, 'nodes:', result_paths);
  }
  if (result_paths.length) {
    const result_path = result_paths[0];
    return result_path;
  }
  return null;
};
